import A from 'const/actionTypes'
import actions from '.'
import Config from '../config'
import firebase from 'firebase'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'
import store from 'store'

const emailUnverifiedUser = (dispatch, gamerId) => {
  dispatch(actions.updateGamer(gamerId, { emailed: true, }))
  firebase.auth().currentUser.sendEmailVerification().then(
    () => {},
    (error) => {
      if (error) { dispatch(actions.alertGamerWithError(error)) }
      console.log(
        'An error occurred verifying your account: ',
        error.message.toString()
      )
    }
  )
}

const signInUser = (currentGamer, dispatch) => {
  if (currentGamer.email && whiteListed(currentGamer.email)) {
    let authData = {
      displayName: currentGamer.displayName,
      email: currentGamer.email,
      photoURL: currentGamer.photoURL,
      providerData: currentGamer.providerData,
      uid: currentGamer.uid,
      username: currentGamer.displayName, // TODO change to username
    }
    dispatch(actions.startListeningToGamer(authData))
    window.heap.identify(currentGamer.uid)
    window.heap.addUserProperties({ email: currentGamer.email })
  } else {
    signOutUnauthorizedUser(dispatch)
  }
}

const signOutUnauthorizedUser = (dispatch) => {
  dispatch({
    type: A.SIGN_OUT,
  })
  dispatch(actions.routeTo('sign-in'))

  let error = 'Your email address is not authorized for access.'
  dispatch({
    type: A.UPDATE_USER_INTERFACE,
    update: {
      error,
    },
  })
}

const routeVerifiedUser = (dispatch, route) => {
  if ((route === 'sign-in') || (route === 'verification')) {
    dispatch(actions.routeTo('dashboard'))
  } else {
    dispatch(actions.routeTo(route))
  }
}

const whiteListed = (email) => {
  let isWhiteListed = false
  const whitelist = store.getState().auth.whitelist
  Object.keys(whitelist).map((whitelistKey) => {
    if (email.indexOf(whitelist[whitelistKey]) >= 0) {
      isWhiteListed = true
    }
  })
  return isWhiteListed
}

export default {
  deleteAccount: () => {
    return (dispatch, getState) => {
      const gamerId = firebase.auth().currentUser.uid
      dispatch(actions.deleteGamer(
        gamerId,
      ))
    }
  },
  linkEmailAndPassword: () => {
    return (dispatch, getState) => {
      const userInterface = getState().userInterface

      if (whiteListed(userInterface.email)) {
        const credential = firebase.auth.EmailAuthProvider.credential(userInterface.email, userInterface.password)

        firebase.auth().currentUser.link(credential).then((gamer) => {
          dispatch({
            type: A.UPDATE_USER_INTERFACE,
            update: {
              confirmPassword: null,
              email: null,
              password: null,
            },
          })
          dispatch(actions.updateGamer(
            gamer.uid,
            {
              providerData: gamer.providerData,
            },
          ))
          dispatch(actions.alertGamer({ message: 'Email Connected.', }))
        }, (error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
      } else {
        dispatch({
          type: A.DISPLAY_ERROR,
          error: 'Email Address Not Authorized',
        })
      }
    }
  },
  linkFacebookAccount: () => {
    return (dispatch, getState) => {
      const provider = new firebase.auth.FacebookAuthProvider()
      Config.FACEBOOK_SCOPES.map((scope) => provider.addScope(scope))

      firebase.auth().currentUser.linkWithPopup(provider).then((result) => {
        if (result.credential) {
          const gamer = result.user

          dispatch(actions.updateGamer(
            gamer.uid,
            {
              providerData: gamer.providerData,
            },
          ))
          dispatch(actions.alertGamer({ message: 'Facebook Connected.', }))
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  linkGoogleAccount: () => {
    return (dispatch, getState) => {
      const provider = new firebase.auth.GoogleAuthProvider()
      // Config.GOOGLE_SCOPES.map((scope) => provider.addScope(scope))

      firebase.auth().currentUser.linkWithPopup(provider).then((result) => {
        if (result.credential) {
          const gamer = result.user

          dispatch(actions.updateGamer(
            gamer.uid,
            {
              providerData: gamer.providerData,
            },
          ))
          dispatch(actions.alertGamer({ message: 'Google Connected.', }))
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  linkTwitterAccount: () => {
    return (dispatch, getState) => {
      const provider = new firebase.auth.TwitterAuthProvider()

      firebase.auth().currentUser.linkWithPopup(provider).then((result) => {
        if (result.credential) {
          const gamer = result.user

          dispatch(actions.updateGamer(
            gamer.uid,
            {
              providerData: gamer.providerData,
            },
          ))
          dispatch(actions.alertGamer({ message: 'Twitter Connected.', }))
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) }})
    }
  },
  signIn: () => {
    return (dispatch, getState) => {
      const userInterface = getState().userInterface
      firebase.auth().signInWithEmailAndPassword(userInterface.email, userInterface.password)
      .then((authResult) => {
        if (authResult && !authResult.error) {
          signInUser(firebase.auth().currentUser, dispatch)
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  signInWithFacebook: () => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SIGNING_IN,
      })
      const provider = new firebase.auth.FacebookAuthProvider()
      Config.FACEBOOK_SCOPES.map((scope) => provider.addScope(scope))

      firebase.auth().signInWithPopup(provider).then((authResult) => {
        if (authResult && !authResult.error) {
          signInUser(firebase.auth().currentUser, dispatch)
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  signInWithGoogle: () => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SIGNING_IN,
      })
      const provider = new firebase.auth.GoogleAuthProvider()
      // Config.GOOGLE_SCOPES.map((scope) => provider.addScope(scope))

      firebase.auth().signInWithPopup(provider).then((authResult) => {
        if (authResult && !authResult.error) {
          signInUser(firebase.auth().currentUser, dispatch)
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  signInWithTwitter: () => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SIGNING_IN,
      })
      const provider = new firebase.auth.TwitterAuthProvider()
      firebase.auth().signInWithPopup(provider).then((authResult) => {
        if (authResult && !authResult.error) {
          let currentGamer = firebase.auth().currentUser

          if (currentGamer.email) {
            signInUser(currentGamer, dispatch)
          } else {
            dispatch({
              type: A.DISPLAY_ERROR,
              error: 'An email address is required in order to play',
            })
            dispatch({
              type: A.SIGN_OUT,
            })
          }
        }
      })
      .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
    }
  },
  signOut: () => {
    return (dispatch, getState) => {
      firebase.auth().signOut().then(() => {
        dispatch(actions.clearCounterStrikeGlobalOffensiveSettings())
        dispatch(actions.clearCurrentGamerProfile())
        dispatch(actions.clearOtherGamerProfile())
        dispatch(actions.clearCurrentGamerPurchaseProfile())
        dispatch(actions.clearFlickPowerRankingCount())
        dispatch(actions.clearFollowThroughPowerRankingCount())
        dispatch(actions.clearGameInterface())
        dispatch(actions.clearGamers())
        dispatch(actions.clearGameSounds())
        dispatch(actions.clearPowerRankingCount())
        dispatch(actions.clearScores())
        dispatch(actions.clearSpeedPowerRankingCount())
        dispatch(actions.clearUserInterface())
        dispatch(actions.clearWeeklyStatistics())
        dispatch(actions.routeTo('sign-in'))
        dispatch(actions.setCurrentGamer({}))
        dispatch(actions.setOtherGamer({}))
        dispatch({ type: A.SIGN_OUT, })
      }, function (error) {
        if (error) { dispatch(actions.alertGamerWithError(error)) }
      })

    }
  },
  signUp: () => {
    return (dispatch, getState) => {
      const userInterface = getState().userInterface
      if (whiteListed(userInterface.email)) {
        firebase.auth().createUserWithEmailAndPassword(userInterface.email, userInterface.password)
        .then((authResult) => {
          console.log('Welcome!')
          window.heap.identify(authResult.uid)
          window.heap.addUserProperties({ email: authResult.email })
        })
        .catch((error) => { if (error) { dispatch(actions.alertGamerWithError(error)) } })
      } else {
        signOutUnauthorizedUser(dispatch)
      }
    }
  },
  startListeningToAuth: () => {
    return (dispatch, getState) => {
      firebase.auth().onAuthStateChanged((authData) => {
        if (authData) {
          if (whiteListed(authData.email)) { // if no whitelist substitute w/ authData.uid
            dispatch(actions.startListeningToGamer(authData))
            dispatch(actions.startListeningToArticles())
            dispatch(actions.startListeningToPowerRankingCount())
            dispatch(actions.startListeningToMobilePowerRankingCount())
            dispatch(actions.startListeningToOverallStatistics())
          } else {
            signOutUnauthorizedUser(dispatch)
          }
        }
      })
    }
  },
  startListeningToFirebase: () => {
    return (dispatch, getState) => {
      firebaseService.subscribe(
        'whitelist',
        (result) => {
          const whitelist = result.val() || {}
          dispatch({
            type: A.SET_WHITELIST,
            whitelist
          })
          dispatch(actions.startListeningToAuth())
          dispatch(actions.startListeningToMobilePowerRankings())
          dispatch(actions.startListeningToPowerRankings())
        },
        N.GAMERS
      )
    }
  },
  startListeningToGamer: (authData) => {
    return (dispatch, getState) => {
      const gamerId = authData.uid

      dispatch({
        type: A.SIGN_IN,
        displayName: authData.displayName,
        email: authData.email,
        photoURL: authData.photoURL,
        providerData: authData.providerData,
        uid: gamerId,
      })

      firebaseService.subscribe(
        'gamers/' + gamerId,
        (result) => {
          const currentGamer = result.val() || {}

          if (!Object.keys(currentGamer).length || !gamerId) {
            if (whiteListed(authData.email)) {
              dispatch(actions.syncGamer(authData))
            } else {
              signOutUnauthorizedUser(dispatch)
            }
          } else {
            if (authData.email !== currentGamer.email) {
              dispatch(actions.updateGamer(gamerId, { email: authData.email, }))
            }
            dispatch(actions.setGamer(gamerId, currentGamer))
            dispatch(actions.setCurrentGamer(currentGamer))
            dispatch(actions.setCurrentGamerProfile(gamerId))
            dispatch(actions.setCurrentGamerPurchaseProfile(gamerId))
            dispatch(actions.startListeningToWeeklyStatistics(gamerId))
            dispatch(actions.clearUserInterface())

            const { routeParams, routing, } = getState()
            const routePriorToAuth = (
              routing.locationBeforeTransitions.state &&
              routing.locationBeforeTransitions.state.nextPathname
            )
            let route = routePriorToAuth || routeParams.route || 'dashboard'

            if (currentGamer.verified) {
              // dispatch(actions.startListeningToNotifications(authData.uid))
              routeVerifiedUser(dispatch, route)
            } else {
              if (currentGamer) {
                if (
                  authData.emailVerified ||
                  ['facebook.com', 'twitter.com'].includes(currentGamer.initialProvider)
                ) {
                  dispatch(actions.updateGamer(gamerId, { verified: true, }))
                } else {
                  if (!currentGamer.emailed) {
                    emailUnverifiedUser(dispatch, gamerId)
                  } else {
                    // dispatch(actions.routeTo('verification'))
                    // TODO - fix to remove verification
                    route = route === 'sign-in' ? 'dashboard' : route
                    routeVerifiedUser(dispatch, route)
                  }
                }
              } else {
                signOutUnauthorizedUser(dispatch)
              }
            }
          }
        },
        N.GAMERS
      )
    }
  },
  startListeningToGamers: () => {
    return (dispatch, getState) => {
      firebaseService.subscribe(
        'gamers',
        (result) => {
          const gamers = result.val() || {}
          dispatch({
            type: A.SET_GAMERS,
            gamers
          })
        },
        N.GAMERS
      )
    }
  },
  unlinkAccount: (providerId) => {
    return (dispatch, getState) => {
      firebase.auth().currentUser.unlink(providerId).then(() => {
        const gamer = firebase.auth().currentUser
        dispatch(actions.updateGamer(
          gamer.uid,
          {
            providerData: gamer.providerData,
          },
        ))
        dispatch(actions.alertGamer({ message: 'Account Disconnected.', }))
      }, (error) => {
        if (error) { dispatch(actions.alertGamerWithError(error)) }
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/auth.js